export const esData = `
  <div class="paragraph">
    <div class="title">¿Qué debo hacer antes de enviar mi teléfono?</div>
    <div class="text-box">
      <div class="text">
      Antes de enviar tu dispositivo, asegúrate de:
      </div>
      <div class="text">
      - Borrar todos los datos personales y eliminar cualquier PIN, contraseña o patrón de desbloqueo
      </div>
      <div class="text">
      - Realizar un restablecimiento completo de fábrica
      </div>
      <div class="text">
      - En iPhones: desconectar tu cuenta de iCloud desactivando la opción “Buscar mi iPhone”
      </div>
      <div class="text">
      - En teléfonos Android: eliminar tu cuenta de Google (Ajustes > Cuentas > Google > Eliminar cuenta)
      </div>
      <div class="text">
      Estos pasos garantizan que el dispositivo ya no esté vinculado a tu cuenta personal y ayudan a evitar bloqueos durante la evaluación. También protegen tu información personal y permiten a nuestro equipo revisar el dispositivo sin complicaciones.
      </div>
    </div>
  </div>

  <div class="paragraph">
    <div class="title">¿Puedo enviar un teléfono con bloqueo de SIM?</div>
    <div class="text-box">
      <div class="text">
      No, no aceptamos teléfonos que estén bloqueados a una operadora específica (dispositivos con bloqueo de SIM).
      </div>
    </div>
  </div>

  <div class="paragraph">
    <div class="title">¿Debo enviar los accesorios (cargador, cable)?</div>
    <div class="text-box">
      <div class="text">
      No es obligatorio, pero sí recomendable. Incluir los accesorios contribuye a la sostenibilidad, fomentando la reutilización y el reciclaje adecuado.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">¿Debo enviar también los auriculares?</div>
    <div class="text-box">
      <div class="text">
      No. Por razones de higiene, los auriculares no se incluirán en la valoración y serán desechados.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">¿Debo enviar la factura de compra?</div>
    <div class="text-box">
      <div class="text">
      No. La factura no es necesaria para la evaluación ni para el proceso de pago. Puedes conservarla para tus propios registros.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">¿Cómo evalúan mi teléfono?</div>
    <div class="text-box">
      <div class="text">
      Una vez que recibimos tu dispositivo en nuestro centro de inspección, utilizamos software de diagnóstico y revisiones manuales para evaluar su estado.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">¿Qué ocurre si el estado que indiqué no coincide con su evaluación?</div>
    <div class="text-box">
      <div class="text">
      Si hay una diferencia, te enviaremos una oferta actualizada por correo electrónico. Si el valor final es igual o hasta 13 € menor que tu valoración inicial, procederemos automáticamente. Si la diferencia es mayor, tendrás 5 días hábiles para aceptar o rechazar la nueva oferta.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">¿Qué pasa si rechazo la oferta actualizada?</div>
    <div class="text-box">
      <div class="text">
      Tu dispositivo te será devuelto sin coste alguno. El proceso de devolución se iniciará en un plazo de 5 días hábiles tras tu confirmación del rechazo.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">¿Qué pasa si no respondo a la oferta actualizada?</div>
    <div class="text-box">
      <div class="text">
      Si no recibimos respuesta en un plazo de 5 días hábiles, la oferta actualizada se considerará aceptada automáticamente y procederemos con el pago.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">¿Qué sucede con mis datos personales?</div>
    <div class="text-box">
      <div class="text">
      Debes borrar todos los datos personales antes de enviar tu dispositivo. Si detectamos datos en el dispositivo, pausaremos el proceso y te contactaremos para solicitar autorización antes de eliminarlos. Cumplimos con el Reglamento General de Protección de Datos (RGPD - Reglamento UE 2016/679).
      </div>
    </div>
  </div>

  <div class="paragraph">
    <div class="title">¿Quién cubre los gastos de envío?</div>
    <div class="text-box">
      <div class="text">
      El envío inicial (hacia nuestro centro de evaluación) es gratuito. Si rechazas nuestra oferta actualizada, también cubriremos el coste del envío de devolución.
      </div>
    </div>
  </div>

  <div class="paragraph">
    <div class="title">¿Qué ocurre si mi paquete se pierde durante el envío?</div>
    <div class="text-box">
      <div class="text">
      Danghuan no se hace responsable de la pérdida de paquetes, incluso si se utiliza la etiqueta de envío proporcionada por nosotros.
      </div>

      <div class="text">
      Sin embargo, si tu paquete parece haberse perdido, estaremos encantados de ayudarte a iniciar el proceso de reclamación con la empresa de mensajería. Para ello:
      </div>

      <div class="text">
      - Asegúrate de haber utilizado la etiqueta oficial de envío y conservar el comprobante de envío
      </div>

      <div class="text">
      - Puedes contactar con nuestro equipo de Atención al Cliente en support@danghuan.eu
      </div>

      <div class="text">
      - Las reclamaciones por pérdida pueden iniciarse a partir de los 15 días naturales desde la fecha de envío
      </div>

      <div class="text">
      Nota: Cualquier compensación potencial está sujeta a la política del transportista, no a la de Danghuan.
      </div>
    </div>


    <div class="paragraph">
      <div class="title">¿Cuándo recibiré el pago?</div>
      <div class="text-box">
        <div class="text">
        Una vez aceptes la oferta final, el pago se procesará por transferencia bancaria en un plazo de 3 días hábiles. Asegúrate de que tu IBAN o la información de pago sean correctos.
        </div>
      </div>
    </div>

    <div class="paragraph">
      <div class="title">¿Puedo cancelar mi operación de recompra?</div>
      <div class="text-box">
        <div class="text">
        Sí, pero solo si tu dispositivo aún no ha sido pagado. Para cancelar, ponte en contacto con nosotros lo antes posible escribiendo a support@danghuan.eu.
        </div>
      </div>
    </div>

    <div class="paragraph">
      <div class="title">¿Cómo cancelo una orden de recompra ya confirmada?</div>
      <div class="text-box">
        <div class="text">
        Si ya has recibido el correo de confirmación, pero deseas cancelar, envíanos un email a support@danghuan.eu con tu número de pedido. Te ayudaremos con el proceso.
        </div>
      </div>
    </div>
  </div>
`;
